import React from 'react';
import { Card, CardContent, Typography, ButtonBase } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';


const Species = ({ speciesInfo }) => {
    const history = useNavigate();
    const openSpecies = () => history(`/species/${speciesInfo.item_type_id || speciesInfo.taxonKey}`);
    const scientificName = speciesInfo.species || speciesInfo.scientific_name || 'Species';
    const commonName = speciesInfo.name || speciesInfo.common_name || '';
    const displayName = commonName || scientificName;
    const hasDistinctScientificName = Boolean(commonName && scientificName && commonName !== scientificName);

    return (
        <Card raised elevation={6} className="atlas-result-card">
            <ButtonBase onClick={openSpecies} className="atlas-card-button">
                <CardContent className="atlas-card-content">
                    <span className="atlas-card-kicker">Species</span>
                    <Typography variant="h5" component="h2" className="atlas-card-title">
                        {displayName}
                    </Typography>
                    {hasDistinctScientificName ? (
                        <div className="atlas-card-subtitle">{scientificName}</div>
                    ) : null}
                    <div className="atlas-metric-row atlas-metric-row--triple">
                        <div>
                            <strong>{Number(speciesInfo.count || 0).toLocaleString()}</strong>
                            <span>observations</span>
                        </div>
                        <div>
                            <strong>{Number(speciesInfo.hotspot_count || 0).toLocaleString()}</strong>
                            <span>hotspots</span>
                        </div>
                        <div>
                            <strong>{Number(speciesInfo.event_count || 0).toLocaleString()}</strong>
                            <span>events</span>
                        </div>
                    </div>
                    <div className="atlas-detail-list">
                        <span>
                            <strong>Why open this</strong>
                            Jump into the species profile to see status, range, open references, hotspots, and seasonal timing together.
                        </span>
                    </div>
                    <span className="atlas-card-link">Inspect species</span>
                </CardContent>
            </ButtonBase>
        </Card>
    );
};

export default Species;
